import ReactGA from "react-ga4";

export const initGA = () => {
  const trackingId = "G-J1DP2B6523";
  if (trackingId) {
    ReactGA.initialize(trackingId);
  }
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (action, params) => {
  if (window.gtag) {
    window.gtag('event', action, params);
  }
};

